import { AUTOMATED_TRANSLATION_LANGUAGES } from 'automated_translation/components/language-picker';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getCurrentCourse } from 'redux/selectors/course';

/**
 * Now, the platform detects the content language based on the content itself.
 * When the language content is detected, the original course language will be that
 * and it will ignore the content language set in the language modal.
 *
 * @returns the current course content language object
 */

const useCurrentCourseContentLanguage = () => {
  const currentCourse = useSelector(getCurrentCourse);

  const originalLanguage = useMemo(() => (
    AUTOMATED_TRANSLATION_LANGUAGES.find((language) => {
      const originalContentLanguage = currentCourse.detectedContentLanguage
        ? currentCourse.detectedContentLanguage.toUpperCase()
        : currentCourse.contentLanguage.toUpperCase();
      return language.translationKey === originalContentLanguage;
    })
  ), [currentCourse.detectedContentLanguage, currentCourse.contentLanguage]);

  return originalLanguage;
};

export default useCurrentCourseContentLanguage;
